import Big from 'big.js'
import { Measure } from '../types'

enum VoltageMeasurementSystem {
  siUnits = 'SI Units',
  derivedSIUnits = 'SI Derived Units',
  cgsUnits = 'CGS Units'
}

// todo: verify conversion correctness
const electricPotentialUnits = {
  nanovolt: {
    displayName: 'Nanovolt',
    codeName: 'nanovolt',
    url: 'nanovolt',
    symbol: 'nV',
    toBaseUnit: (value: Big) => value.times(1e-9),
    fromBaseUnit: (value: Big) => value.div(1e-9),
    system: VoltageMeasurementSystem.siUnits
  },
  microvolt: {
    displayName: 'Microvolt',
    codeName: 'microvolt',
    url: 'microvolt',
    symbol: 'μV',
    toBaseUnit: (value: Big) => value.times(1e-6),
    fromBaseUnit: (value: Big) => value.div(1e-6),
    system: VoltageMeasurementSystem.siUnits
  },
  millivolt: {
    displayName: 'Millivolt',
    codeName: 'millivolt',
    url: 'millivolt',
    symbol: 'mV',
    toBaseUnit: (value: Big) => value.times(1e-3),
    fromBaseUnit: (value: Big) => value.div(1e-3),
    system: VoltageMeasurementSystem.siUnits
  },
  volt: {
    displayName: 'Volt',
    codeName: 'volt',
    url: 'volt',
    symbol: 'V',
    toBaseUnit: (value: Big) => value,
    fromBaseUnit: (value: Big) => value,
    system: VoltageMeasurementSystem.siUnits
  },
  kilovolt: {
    displayName: 'Kilovolt',
    codeName: 'kilovolt',
    url: 'kilovolt',
    symbol: 'kV',
    toBaseUnit: (value: Big) => value.times(1e3),
    fromBaseUnit: (value: Big) => value.div(1e3),
    system: VoltageMeasurementSystem.siUnits
  },
  megavolt: {
    displayName: 'Megavolt',
    codeName: 'megavolt',
    url: 'megavolt',
    symbol: 'MV',
    toBaseUnit: (value: Big) => value.times(1e6),
    fromBaseUnit: (value: Big) => value.div(1e6),
    system: VoltageMeasurementSystem.siUnits
  },
  gigavolt: {
    displayName: 'Gigavolt',
    codeName: 'gigavolt',
    url: 'gigavolt',
    symbol: 'GV',
    toBaseUnit: (value: Big) => value.times(1e9),
    fromBaseUnit: (value: Big) => value.div(1e9),
    system: VoltageMeasurementSystem.siUnits
  },


  watt_per_ampere: {
    displayName: 'Watt per ampere',
    codeName: 'watt_per_ampere',
    url: 'watt-per-ampere',
    symbol: 'W/A',
    toBaseUnit: (value: Big) => value,
    fromBaseUnit: (value: Big) => value,
    system: VoltageMeasurementSystem.derivedSIUnits
  },


  abvolt: {
    displayName: 'Abvolt',
    codeName: 'abvolt',
    url: 'abvolt',
    symbol: 'abV',
    toBaseUnit: (value: Big) => value.times(1e-8),
    fromBaseUnit: (value: Big) => value.div(1e-8),
    system: VoltageMeasurementSystem.cgsUnits
  },
  statvolt: {
    displayName: 'Statvolt',
    codeName: 'statvolt',
    url: 'statvolt',
    symbol: 'stV',
    toBaseUnit: (value: Big) => value.times(299.79245809),
    fromBaseUnit: (value: Big) => value.div(299.79245809),
    system: VoltageMeasurementSystem.cgsUnits
  }
}

export const electricPotential: Measure = {
  displayName: 'Electric potential',
  codeName: 'electricPotential',
  url: 'electric-potential',
  units: electricPotentialUnits,
  baseUnit: electricPotentialUnits.volt,
  defaultFromUnit: electricPotentialUnits.volt,
  defaultToUnit: electricPotentialUnits.millivolt
}
